/*
Author: Eli Elad Elrom
Website: https://EliElrom.com
License: MIT License
Component: src/widgets/WordsWidget/WordsWidget.css.ts
*/

import styled from 'styled-components';
import { typeStyleRevxNeueText2 } from '../../../styles/typography';
import { breakpoint } from '../../../styles/breakpoints';

export const Wrapper = styled.div`
  ${typeStyleRevxNeueText2}

  ${breakpoint('mobile')`
    display: flex;
    overflow: auto;
    width: 100vw;
    height: 600px;
    padding-left: 1em;
  `}
`;
